import i18n from 'i18next';
import { AllHWTopic } from '../constants/hw';
import Types from '../constants/hwReducer';
import store from '../store';
import TypesDelete from './../constants/AsyncTable';
import CustomTasksService from './../services/customTasks.service';
import HomeworkService from './../services/homework.service';
import { default as homework_V2Service, default as HomeworkServiceV2 } from './../services/homework_V2.service';
import { reloadTable } from './AsyncTable';
import { countDate } from './date';
import { getSingleGroup } from './groups';
import { closeRequestModal, openRequestModal } from './modals';
import { getErrorNotification } from './toast';
import { setNewHwHeight } from './user';

function getTabeToDelete() {
    const state = store.getState();
    const { values } = state.form && state.form['from-tableComponent'];
    const e = values;
    let arrToSave = [];
    for (let i in e) {
        const obj = JSON.parse(i);
        if (obj.code !== 'do_delete') continue;
        if (obj && obj.id) {
            if (obj.code === 'do_delete' && e[i]) arrToSave.push(obj.id);
        }
    }
    return arrToSave.length ? arrToSave : false;
}

function checkArrayRange(array) {
    return array.map(item => {
        const gameType = +item.game_type;
        const topic = +item.topic;

        switch (gameType) {
            case 3:
                if (topic > 24) item.topic = '0';
                break;
            case 4:
                if (topic < 53) item.topic = '53';
                break;
            case 5:
            case 6:
                if (topic < 12 || topic > 24) item.topic = '12';
                break;
        }

        return item;
    });
}

function sendCopyStudentHw(data) {
    return (dispatch, getState) => {
        closeRequestModal()(dispatch, getState);
        HomeworkService.CopyStudentHw(data).then(res => {
            if (res) {
            }
        });
    };
}

function copyHw(data) {
    return async (dispatch, getState) => {
        const res = await HomeworkService.copyHw(data);
        if (res) {
            TasksCalendar(data.group_id)(dispatch, getState);
            closeRequestModal()(dispatch, getState);
        }
        return res;
    };
}

function CopyOtherStudents(data) {
    return async (dispatch, getState) => {
        const res = await HomeworkService.CopyOtherStudents(data);
        if (res) {
            TasksCalendar(data.group_id)(dispatch, getState);
            closeRequestModal()(dispatch, getState);
        }
    };
}

function copyHwOtherGroup(data) {
    return (dispatch, getState) => {
        HomeworkService.copyHwOtherGroup(data).then(res => {
            // TasksCalendar(data.copy_group_id)(dispatch, getState);
            closeRequestModal()(dispatch, getState);
        });
    };
}
function sendMessage(data) {
    return async (dispatch, getState) => {
        await HomeworkService.notification(data, false);
        await getSingleGroup(data.group_id)(dispatch);
        closeRequestModal()(dispatch, getState);
    };
}

function setData(args) {
    return dispatch => {
        dispatch({
            type: Types.CHANGE,
            homework: args,
        });
    };
}

function getAllStatData(...args) {
    return async (dispatch, getState) => {
        return await HomeworkService.callAllStat(...args);
    };
}

function createNewHw(args) {
    return async (dispatch, getState) => {
        await homework_V2Service.createOldHw(args.data, args.query);
        TasksCalendar(args.data.group_id)(dispatch, getState);
        reloadTable()(dispatch, getState);
        openRequestModal({
            opened: true,
            data: {
                id: args,
                note: args.data.note,
                header: i18n.t('groups.enter_message'),
                modaltype: 'SendMessageModal',
            },
        })(dispatch, getState);
    };
}

function createNewHw_V2(args) {
    return async (dispatch, getState) => {
        await HomeworkServiceV2.createNewHw(args.data, args.query);
        TasksCalendar(args.data.group_id)(dispatch, getState);
        reloadTable()(dispatch, getState);
        openRequestModal({
            opened: true,
            data: {
                id: args,
                note: args.data.note,
                header: i18n.t('groups.enter_message'),
                modaltype: 'SendMessageModal',
            },
        })(dispatch, getState);
    };
}

function initTemplatesName() {
    return async (dispatch, getState) => {
        let response = await HomeworkService.getTemplatesName(false);
        response = response.payload;
        // .then(response => {
        const stored = getState().HW;
        let selected = stored.templatesName_select;
        // eslint-disable-next-line
        if (
            response.templatesName.length &&
            // eslint-disable-next-line
            !response.templatesName.find(el => el.value == selected)
        ) {
            selected = null;
        }
        dispatch({
            type: Types.INIT_TEMPLATES_NAME,
            homework: {
                ...response,
                templatesName_select: selected || response.templatesName[0].value,
            },
        });
    };
}

function copyTemplate(data) {
    return async (dispatch, getState) => {
        HomeworkService.copyTemplate(data).then(res => {
            reloadTable()(dispatch, getState);

            closeRequestModal()(dispatch, getState);
        });
    };
}

function removeHWGolden(data) {
    return async (dispatch, getState) => {
        return await HomeworkService.anull(false, data);
    };
}

function removeHW(data) {
    return (dispatch, getState) => {
        HomeworkService.anull(false, data).then(response => {
            closeRequestModal()(dispatch, getState);
            if (!data.student_id) TasksCalendar(data.group_id)(dispatch, getState);

            reloadTable()(dispatch, getState);
        });
    };
}

function deleteHW(data, suppressUIUpdate = false) {
    return async (dispatch, getState) => {
        if (!suppressUIUpdate) {
            const e = getState().form['from-tableComponent'].values;
            const arrToSave = [];
            const objToSave = {};
            for (let i in e) {
                const obj = JSON.parse(i);
                if (obj && obj.id) {
                    if (!objToSave[obj.id]) objToSave[obj.id] = {};
                    objToSave[obj.id][obj.code] = e[i];
                } else if (obj && obj.id) {
                    if (!objToSave[obj.id]) objToSave[obj.id] = {};
                    objToSave[obj.id][obj.code] = e[i];
                }
            }
            delete objToSave[data.id];
            for (let i in objToSave) {
                if (!isNaN(+i)) {
                    arrToSave.push({
                        ...objToSave[i],
                        id: i.length > 20 ? i : JSON.parse(i),
                    });
                } else {
                    arrToSave.push({
                        ...objToSave[i],
                        id: i.length > 20 ? i : JSON.parse(i),
                    });
                }
            }
            arrToSave.sort((a, b) => (a.order > b.order ? (b.order > a.order ? 0 : 1) : -1));
            dispatch({
                type: TypesDelete.ADD_DATA_HW_ROW,
                payload: arrToSave,
            });
        }

        const res = await HomeworkService.deleteHw(false, data);

        if (!suppressUIUpdate) {
            closeRequestModal()(dispatch, getState);
        }
        return res;
    };
}

function deleteHWTeacherTemplate(data, suppressUIUpdate = false) {
    return async (dispatch, getState) => {
        if (!suppressUIUpdate) {
            const e = getState().form['from-tableComponent'].values;
            const arrToSave = [];
            const objToSave = {};
            for (let i in e) {
                const obj = JSON.parse(i);
                if (obj && obj.id) {
                    if (!objToSave[obj.id]) objToSave[obj.id] = {};
                    objToSave[obj.id][obj.code] = e[i];
                } else if (obj && obj.id) {
                    if (!objToSave[obj.id]) objToSave[obj.id] = {};
                    objToSave[obj.id][obj.code] = e[i];
                }
            }
            delete objToSave[data.id];
            for (let i in objToSave) {
                if (!isNaN(+i)) {
                    arrToSave.push({
                        ...objToSave[i],
                        id: i,
                    });
                } else {
                    arrToSave.push({
                        ...objToSave[i],
                        id: i,
                    });
                }
            }
            arrToSave.sort((a, b) => (a.order > b.order ? (b.order > a.order ? 0 : 1) : -1));
            for (let i = 0; i < arrToSave.length; i++) {
                if (i && +arrToSave[i - 1].order + 1 !== +arrToSave[i].order) {
                    arrToSave[i].order = +arrToSave[i - 1].order + 1;
                }
            }
            dispatch({
                type: TypesDelete.ADD_DATA_HW_ROW,
                payload: arrToSave,
            });
        }

        const res = await homework_V2Service.deleteHwTeacherTemplate(false, data);

        if (!suppressUIUpdate) {
            closeRequestModal()(dispatch, getState);
        }
        return res;
    };
}

function deleteHWTeacher(data, suppressUIUpdate = false) {
    return async (dispatch, getState) => {
        if (!suppressUIUpdate) {
            const e = getState().form['from-tableComponent'].values;
            const arrToSave = [];
            const objToSave = {};
            for (let i in e) {
                const obj = JSON.parse(i);
                if (obj && obj.id) {
                    if (!objToSave[obj.id]) objToSave[obj.id] = {};
                    objToSave[obj.id][obj.code] = e[i];
                } else if (obj && obj.id) {
                    if (!objToSave[obj.id]) objToSave[obj.id] = {};
                    objToSave[obj.id][obj.code] = e[i];
                }
            }
            delete objToSave[data.id];
            for (let i in objToSave) {
                if (!isNaN(+i)) {
                    arrToSave.push({
                        ...objToSave[i],
                        id: i,
                    });
                } else {
                    arrToSave.push({
                        ...objToSave[i],
                        id: i,
                    });
                }
            }
            arrToSave.sort((a, b) => (a.order > b.order ? (b.order > a.order ? 0 : 1) : -1));
            for (let i = 0; i < arrToSave.length; i++) {
                if (i && +arrToSave[i - 1].order + 1 !== +arrToSave[i].order) {
                    arrToSave[i].order = +arrToSave[i - 1].order + 1;
                }
            }
            dispatch({
                type: TypesDelete.ADD_DATA_HW_ROW,
                payload: arrToSave,
            });
        }

        const res = await homework_V2Service.deleteHwTeacher(false, data);

        if (!suppressUIUpdate) {
            closeRequestModal()(dispatch, getState);
        }
        return res;
    };
}

function deleteHWAdmin(data, suppressUIUpdate = false) {
    return async (dispatch, getState) => {
        if (!suppressUIUpdate) {
            const e = getState().form['from-tableComponent'].values;
            const arrToSave = [];
            const objToSave = {};
            for (let i in e) {
                const obj = JSON.parse(i);
                if (obj && obj.id) {
                    if (!objToSave[obj.id]) objToSave[obj.id] = {};
                    objToSave[obj.id][obj.code] = e[i];
                } else if (obj && obj.id) {
                    if (!objToSave[obj.id]) objToSave[obj.id] = {};
                    objToSave[obj.id][obj.code] = e[i];
                }
            }
            delete objToSave[data];
            for (let i in objToSave) {
                if (!isNaN(+i)) {
                    arrToSave.push({
                        ...objToSave[i],
                        id: i,
                    });
                } else {
                    arrToSave.push({
                        ...objToSave[i],
                        id: i,
                    });
                }
            }
            arrToSave.sort((a, b) => (a.order > b.order ? (b.order > a.order ? 0 : 1) : -1));
            for (let i = 0; i < arrToSave.length; i++) {
                if (i && +arrToSave[i - 1].order + 1 !== +arrToSave[i].order) {
                    arrToSave[i].order = +arrToSave[i - 1].order + 1;
                }
            }
            dispatch({
                type: TypesDelete.ADD_DATA_HW_ROW,
                payload: arrToSave,
            });
        }

        const res = await HomeworkServiceV2.deleteHwAdmin(data);

        if (!suppressUIUpdate) {
            closeRequestModal()(dispatch, getState);
        }
        return res;
    };
}

function deleteNotSavedRow(id) {
    return (dispatch, getState) => {
        const e = getState().form['from-tableComponent'].values;
        const arrToSave = [];
        const objToSave = {};
        for (let i in e) {
            const obj = JSON.parse(i);
            if (obj && obj.id) {
                if (!objToSave[obj.id]) objToSave[obj.id] = {};
                objToSave[obj.id][obj.code] = e[i];
            } else if (obj && obj.id) {
                if (!objToSave[obj.id]) objToSave[obj.id] = {};
                objToSave[obj.id][obj.code] = e[i];
            }
        }
        delete objToSave[id];
        for (let i in objToSave) {
            if (!isNaN(+i)) {
                arrToSave.push({
                    ...objToSave[i],
                    id: i,
                });
            } else {
                arrToSave.push({
                    ...objToSave[i],
                    id: i,
                });
            }
        }
        arrToSave.sort((a, b) => (a.order > b.order ? (b.order > a.order ? 0 : 1) : -1));
        for (let i = 0; i < arrToSave.length; i++) {
            if (i && +arrToSave[i - 1].order + 1 !== +arrToSave[i].order) {
                arrToSave[i].order = +arrToSave[i - 1].order + 1;
            }
        }
        dispatch({
            type: TypesDelete.ADD_DATA_HW_ROW,
            payload: arrToSave,
        });
        closeRequestModal()(dispatch, getState);
    };
}

function processDate(item) {
    const d = new Date(item);
    const _month = String(d.getMonth() + 1).padStart(2, '0');
    const _date = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${_month}-${_date}`;
}

function mergeCalendarTasks(tasks) {
    const mergedMap = new Map();

    for (const item of tasks) {
        const key = item.start;

        if (!mergedMap.has(key)) {
            mergedMap.set(key, { ...item });
        } else {
            const existing = mergedMap.get(key);

            // Объединяем id
            if (item.id) {
                existing.id = Array.from(new Set([...(existing.id || []), ...item.id]));
            }

            // Сохраняем default, если есть
            if (item.default) {
                existing.default = true;
            }

            // Перезаписываем остальные поля, если они есть
            if (item.className) {
                existing.className = item.className;
            }

            if (item.date) {
                existing.date = item.date;
            }

            mergedMap.set(key, existing);
        }
    }

    return Array.from(mergedMap.values()).sort((a, b) => a.start - b.start);
}

function getStudentsSingleHW(group_id, existingDates) {
    return async (dispatch, getState) => {
        const res = await HomeworkService.GetStudentRelatedHW({
            group_id,
        });

        const { list } = res.payload;
        const additionalDatesList = [];

        for (const item of list) {
            if (!item.different_dates) continue;
            for (const datesItem of item.different_dates) {
                const dateObj = processStartDateObject(datesItem);
                const index = additionalDatesList.findIndex(el => el.start === dateObj.start);
                if (index === -1) {
                    additionalDatesList.push({
                        start: dateObj.start,
                        id: [item.user_id],
                        className: 'additionalDates',
                        date: processDate(dateObj.start - 1000),
                        default: false,
                    });
                } else {
                    additionalDatesList[index].id.push(item.user_id);
                }
            }
        }

        return additionalDatesList;
    };
}

function processStartDateObject(item) {
    return {
        start: +new Date(+new Date(item) + +new Date(item).getTimezoneOffset() * 60 * 1000),
        default: true,
    };
}

function processCalendarDatesArray(response) {
    let array = [];

    response.dates.sort((a, b) => +new Date(a) - +new Date(b));
    for (let item of response.dates) {
        let dateItem = processStartDateObject(item);
        array.push(dateItem);
    }
    return array;
}

function TasksCalendar(group_id) {
    return async function (dispatch, getState) {
        const response = await HomeworkService.HomeworkListTeacherCalendar(false, {
            group_id,
            size: 9999,
        });
        if (!response) {
            return { redirect: '/groups' };
        }
        let array = [];
        if (response && response.dates) {
            array = processCalendarDatesArray(response);
        }
        const singleStundentDays = await dispatch(getStudentsSingleHW(group_id, array));

        dispatch({
            type: Types.INIT_CALENDAR_TASKS,
            homework: {
                calendar_tasks: [...array, ...singleStundentDays].sort(
                    (a, b) => +new Date(a.start) - +new Date(b.start)
                ),
            },
        });
    };
}

function deleteAllHW() {
    return async (dispatch, getState) => {
        const table = getState().AsyncTable?.table?.data || [];
        const tasks = [];

        for (let i = 0; i < table.length; i++) {
            tasks.push(HomeworkService.deleteHw(false, { id: table[i].id }));
        }

        try {
            await Promise.all(tasks);
            await reloadTable()(dispatch, getState);
            closeRequestModal()(dispatch, getState);
        } catch (err) {
            throw err;
        }
    };
}

function activateTableFetch() {
    return (dispatch, getState) => {
        dispatch({
            type: TypesDelete.ACTIVATE_FETCHING,
            payload: {
                fetching: true,
            },
        });
    };
}

function saveHW(tasks) {
    return (dispatch, getState) => {
        setNewHwHeight()(dispatch, getState);
        dispatch({
            type: TypesDelete.ACTIVATE_FETCHING,
            payload: {
                fetching: true,
            },
        });

        const { HW } = getState();
        HomeworkService.saveModification({
            template_id: HW.templatesName_select,
            topic_number: HW.topic,
            week_day: +HW.day + 1,
            tasks,
        }).then(response => {
            reloadTable()(dispatch, getState);
        });
    };
}

function saveHWName(name) {
    return async function (dispatch, getState) {
        return await HomeworkService.saveModification({
            template_id: name,
            topic_number: 0,
            week_day: 1,
            tasks: [
                {
                    topic: '0',
                    digit: 1,
                    game_type: 'Ded',
                    duration: 0,
                    min_level: 1,
                    max_level: 100,
                },
            ],
        }).then(res => {});
    };
}

function saveHWGroup(date, group_id, tasks, student_id = null, topic, templatesName, source, indiv_students = []) {
    return (dispatch, getState) => {
        setNewHwHeight()(dispatch, getState);
        dispatch({
            type: Types.CHANGE,
            homework: { load: true },
        });
        const from = student_id && student_id !== -1 ? { student_id } : { group_id };
        tasks.sort((a, b) => (a.order > b.order ? (b.order > a.order ? 0 : 1) : -1));

        for (let i = 0; i < tasks.length; i++) {
            if (i === 0 && +tasks[i].order !== 1) {
                tasks[i].order = 1;
            }
            if (i && +tasks[i - 1].order + 1 !== +tasks[i].order) {
                tasks[i].order = +tasks[i - 1].order + 1;
            }
        }
        let minMaxErrors = { text: null, index: null };
        for (let items of tasks) {
            const min = +items.min_time;
            const start = +items.start_time;
            const max = +items.max_time;
            if (items.hw_age === '-1') delete items.hw_age;

            if (start && min > start) {
                minMaxErrors.text = 'error.min_time_start_time';
                break;
            } else if (start && max !== 0 && start > max) {
                items.start_time = max;
            } else if (!start && min > max) {
                minMaxErrors.text = 'error.min_time_max_time';
                break;
            } else if (!start && max < min) {
                minMaxErrors.text = 'error.max_time_min_time';
                break;
            }
        }
        if (minMaxErrors.text) {
            getErrorNotification(i18n.t(minMaxErrors.text));
            return dispatch({
                type: Types.CHANGE,
                homework: { load: false },
            });
        }
        dispatch({
            type: TypesDelete.ADD_DATA_HW_ROW,
            payload: tasks,
        });
        return homework_V2Service
            .saveGroupHW(
                {
                    date,
                    ...from,
                    tasks,
                    indiv_students,
                },
                {
                    topic,
                    templatesName,
                }
            )
            .then(response => {
                dispatch({
                    type: Types.CHANGE,
                    homework: { load: false },
                });
                reloadTable()(dispatch, getState);
                return response;
            });
    };
}
function initStudentsList(group_id, date, selectedStudentId = null) {
    return async (dispatch, getState) => {
        dispatch({
            type: Types.INIT_STUDENTS_LIST,
            homework: {
                students_list: [],
            },
        });

        const reversedDate = date.split('-').reverse().join('-');
        TasksCalendar(group_id)(dispatch, getState);
        const response = await homework_V2Service.getHwUsersStart(false, { group_id, date: reversedDate });

        const HW = getState().HW;
        const { calendar_tasks } = HW;

        let list = response.payload;
        const tasks = calendar_tasks;
        const recievedDate = countDate(new Date(date));

        const targetDate = tasks.find(el => countDate(el.start) === recievedDate);

        if (targetDate && targetDate.id && targetDate.id.length) {
            let array = [];
            for (const singleUserId of targetDate.id) {
                array.push(list.find(el => el.id === singleUserId));
            }
            if (array.length) {
                list = array;

                const isStidentInList = array.findIndex(el => el.id === selectedStudentId) || -1;
                selectedStudentId = isStidentInList && isStidentInList === -1 ? array[0].id : array[isStidentInList].id;
            }
        }

        dispatch({
            type: Types.INIT_STUDENTS_LIST,
            homework: {
                students_list: list,
                student: selectedStudentId ? selectedStudentId : list && list.length && list[0].id,
            },
        });
    };
}

function copyLastDayHW() {
    return (dispatch, getState) => {
        const { HW } = getState();
        HomeworkService.copyLastDay({
            day: +HW.day + 1,
            template_id: HW.templatesName_select,
            topic: HW.topic,
        }).then(response => {
            reloadTable()(dispatch, getState);
        });
    };
}

function copyPreviousDayHWSettings() {
    return (dispatch, getState) => {
        const { HW } = getState();
        CustomTasksService.copyPrevioustDay({
            from: +HW.day,
            template_id: HW.templatesName_select,
        }).then(response => {
            reloadTable()(dispatch, getState);
        });
    };
}

function clearHwData() {
    return (dispatch, getState) => {
        dispatch({
            type: Types.CLEAR_HW_DATA,
        });
    };
}

// Збереження змін в моєму шаблоні
function saveHWTemplate(tasks) {
    return (dispatch, getState) => {
        setNewHwHeight()(dispatch, getState);
        dispatch({
            type: TypesDelete.ACTIVATE_FETCHING,
            payload: {
                fetching: true,
            },
        });

        const { HW } = getState();
        HomeworkServiceV2.saveModification({
            template_id: Number(HW.templatesName_select),
            topic_number: Number(HW.topic),
            week_day: +HW.day + 1,
            tasks,
        }).then(response => {
            reloadTable()(dispatch, getState);
        });
    };
}

// Записати у стейт масив змістів ДЗ
function setTemplatesName(templatesName) {
    return {
        type: Types.SET_TEMPLATES_NAME,
        payload: templatesName,
    };
}

// Записуємо у стейт прапорець, показувати кнопку чи ні
function hideSubmitButton(isHidden) {
    return {
        type: Types.HIDE_SUBMIT_BUTTON,
        payload: isHidden,
    };
}
function processLowerTopic(current, selected) {
    if (!current || !selected) {
        return false;
    }
    if (current >= 8 && current <= 11) {
        return selected < 8;
    } else if (current >= 12 && current <= 20) {
        return selected < 12;
    } else if (current >= 21 && current <= 24) {
        return selected < 21;
    } else if (current >= 53 && current <= 62) {
        return selected < 53;
    }
    return false;
}

function defineGroupTopicBlock(topic) {
    if (topic >= 8 && topic <= 11) {
        return 1;
    } else if (topic >= 12 && topic <= 20) {
        return 2;
    } else if (topic >= 21 && topic <= 24) {
        return 3;
    } else if ([53, 61, 62, 56, 57].includes(topic)) {
        return 4;
    } else if ([58, 60, 59, 55, 54].includes(topic)) {
        return 5;
    } else {
        return 0;
    }
}

function checkGroupTopicShift(current, selected) {
    if (!selected && current) {
        selected = 'S 2';
    }

    const currentBlock = defineGroupTopicBlock(findGroupTopicNumberByName(current));
    const selectedBlock = defineGroupTopicBlock(findGroupTopicNumberByName(selected));

    if (currentBlock === selectedBlock) {
        return -1;
    }

    if (currentBlock > selectedBlock) {
        return true;
    }
    return false;
}

function findGroupTopicNumberByName(groupTopicName) {
    if (!groupTopicName) groupTopicName = 'S 2';
    const topic = AllHWTopic.find(
        el => el.label.replaceAll(' ', '').toLowerCase() === groupTopicName.replaceAll(' ', '').toLowerCase()
    );
    return topic && typeof topic.value === 'number' ? topic.value : null;
}

function getCustomTopics() {
    return async (dispatch, getState) => {
        const res = await homework_V2Service.getCustomTopics();
        const normalizedTopics = Array.isArray(res)
            ? res.map(topic => topic.replace(/\s+/g, '').replace(/([A-Z]+)(\d+)/, '$1 $2'))
            : [];

        dispatch({
            type: Types.INIT_CUSTOM_TOPICS,
            payload: normalizedTopics,
        });
    };
}

export {
    activateTableFetch,
    checkArrayRange,
    checkGroupTopicShift,
    clearHwData,
    copyHw,
    copyHwOtherGroup,
    copyLastDayHW,
    CopyOtherStudents,
    copyPreviousDayHWSettings,
    copyTemplate,
    createNewHw,
    createNewHw_V2,
    deleteAllHW,
    deleteHW,
    deleteHWAdmin,
    deleteHWTeacher,
    deleteHWTeacherTemplate,
    deleteNotSavedRow,
    findGroupTopicNumberByName,
    getAllStatData,
    getTabeToDelete,
    hideSubmitButton,
    initStudentsList,
    initTemplatesName,
    mergeCalendarTasks,
    processLowerTopic,
    removeHW,
    removeHWGolden,
    saveHW,
    saveHWGroup,
    saveHWName,
    saveHWTemplate,
    sendCopyStudentHw,
    sendMessage,
    setData,
    setTemplatesName,
    TasksCalendar,
    getCustomTopics,
};
